import { Component, DestroyRef, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavStateService, INavStateConfig, SideNavMode } from '../services/nav-state/nav-state.service';
import { fromEvent, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { GlobalSideNavContentComponent } from '../global-side-nav-content/global-side-nav-content.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'global-side-nav',
  templateUrl: './global-side-nav.component.html',
  styleUrls: ['./global-side-nav.component.scss'],
  imports: [CommonModule, MatSidenavModule, GlobalSideNavContentComponent],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class GlobalSideNavComponent implements OnInit {
  public navStateConfig$: Observable<INavStateConfig>;
  private currentNavStateConfig?: INavStateConfig;
  private _mainSlotRef?: ElementRef<HTMLElement>;
  private boundMainSlotEl: HTMLElement | null = null;

  constructor (
    private navStateService: NavStateService,
    private destroyRef: DestroyRef,
  ) {}

  get mainSlotRef (): ElementRef<HTMLElement> | undefined {
    return this._mainSlotRef;
  }

  @ViewChild('mainSlot', { read: ElementRef })
  set mainSlotRef (ref: ElementRef<HTMLElement> | undefined) {
    this._mainSlotRef = ref;
    const mainSlotEl = ref?.nativeElement;
    if (!mainSlotEl || this.boundMainSlotEl === mainSlotEl) {
      return;
    }

    this.boundMainSlotEl = mainSlotEl;
    this.registerCloseOut(this.boundMainSlotEl);
    this.scheduleMarginOverride(this.boundMainSlotEl);
  }

  @HostListener('window:resize')
  onWindowResize (): void {
    this.scheduleMarginOverride(this.boundMainSlotEl);
  }

  ngOnInit (): void {
    this.navStateConfig$ = this.navStateService.getLatestConfig$();
    this.navStateConfig$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((config) => {
        this.currentNavStateConfig = config;
        if (this.boundMainSlotEl) {
          this.scheduleMarginOverride(this.boundMainSlotEl);
        }
      });
  }

  private registerCloseOut (el: HTMLElement): void {
    fromEvent<MouseEvent>(el, 'click', { capture: true })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.navStateService.closeSideNav());
  }

  private scheduleMarginOverride (el?: HTMLElement): void {
    if (!el) {
      return;
    }

    const mode = this.currentNavStateConfig?.sideNav?.matSideNavMode;
    const marginLeft = mode === SideNavMode.SIDE ? '88px' : '0px';

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        el.style.setProperty('margin-inline-start', marginLeft);
        el.style.setProperty('margin-left', marginLeft);
      });
    });
  }
}
